import { render, staticRenderFns } from "./CreateDeliveryBill.vue?vue&type=template&id=480106ec&scoped=true&"
import script from "./CreateDeliveryBill.vue?vue&type=script&lang=js&"
export * from "./CreateDeliveryBill.vue?vue&type=script&lang=js&"
import style0 from "./CreateDeliveryBill.vue?vue&type=style&index=0&id=480106ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480106ec",
  null
  
)

export default component.exports